import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "20",
  fill: "none",
  viewBox: "0 0 23.999 19.448"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E5E3DF",
      d: "M8.345 12.379a.52.52 0 0 0-.518-.517H2v5.068c0 .286.232.518.518.518h5.31a.52.52 0 0 0 .517-.518zm2 4.551a2.52 2.52 0 0 1-2.518 2.518h-5.31A2.52 2.52 0 0 1 0 16.93v-6.068c0-2.945.489-5.269 1.505-7.06C2.535 1.985 4.059.803 5.948.068a1 1 0 1 1 .725 1.864c-1.524.592-2.656 1.497-3.428 2.857-.686 1.21-1.124 2.847-1.224 5.073h5.806a2.52 2.52 0 0 1 2.518 2.517zM21.999 12.379a.52.52 0 0 0-.518-.517h-5.827v5.068c0 .286.233.518.518.518h5.31a.52.52 0 0 0 .517-.518zm2 4.551a2.52 2.52 0 0 1-2.518 2.518h-5.31a2.52 2.52 0 0 1-2.517-2.518v-6.068c0-2.945.489-5.269 1.505-7.06C16.19 1.985 17.713.803 19.602.068a1 1 0 1 1 .725 1.864c-1.524.592-2.656 1.497-3.428 2.857-.686 1.21-1.124 2.847-1.223 5.073h5.805A2.52 2.52 0 0 1 24 12.38z"
    }, null, -1)
  ]))]))
}
export default { render: render }